<script setup lang="ts">
import { XModal, XButton } from '@clicksign/excalibur';
import { useI18n } from '#i18n';

type WhyPixModalEmit = {
  (e: 'close'): void;
};

const emit = defineEmits<WhyPixModalEmit>();

function closeModal() {
  emit('close');
}

const { t } = useI18n();
</script>

<template>
  <XModal
    is-open
    persistent
    scrollable
    data-testid="whyPixModal"
    :modal-classes="[$style.modal]"
    :header-classes="[$style.header]"
    @close="closeModal"
  >
    <h4>{{ t('requirement.pix.tutorial.whyPix.modal.title') }}</h4>
    <h5>{{ t('requirement.pix.tutorial.whyPix.modal.whatIsPixTitle') }}</h5>
    <p>{{ t('requirement.pix.tutorial.whyPix.modal.whatIsPixDescription') }}</p>

    <h5>{{ t('requirement.pix.tutorial.whyPix.modal.whySignWithPixTitle') }}</h5>
    <p>{{ t('requirement.pix.tutorial.whyPix.modal.whySignWithPixDescription') }}</p>

    <p>{{ t('requirement.pix.tutorial.whyPix.modal.whySignWithPixDescriptionTwo') }}</p>
    <p>{{ t('requirement.pix.tutorial.whyPix.modal.senderAuthMethod') }}</p>

    <template #actions>
      <XButton
        data-testid="closeModalButton"
        @click="closeModal"
      >
        {{ t('common.close') }}
      </XButton>
    </template>
  </XModal>
</template>

<style lang="scss" module>
.modal {
  text-align: left;

  .header {
    display: none;
  }
}
</style>
